// import { checkPermission } from './scopes.config'
// import { domainTypes } from '../store/domainManageStore'
// import { useAuthStore } from '../store/authStore'
import { checkPermission } from '../utilities/checkPermission'

// const is_admin: boolean = !!useAuthStore.getState().userData?.is_admin

export const handleViewPermission = (key: string) => {
  return [`view_${key}`, `view_all_${key}`, `view_team_${key}`]
}

export interface RouterMenuProps {
  id: number
  path?: string
  parent_id: null | number
  icon?: string
  label: string
  key: string
  slug?: string
  permission_slugs: string | string[]
  //  permission_slugs: boolean
  hasAccess?: boolean

  slugOptions?: string[]
  breadcrumb?: string[]
  isDetails?: boolean
  isExpanded?: boolean
  isSidebarMenu?: boolean
  hasChild?: boolean
  hasDivider?: boolean
  pathOverride?: string
  publicPermission?: boolean
}

// dashboard

const LOGIN: RouterMenuProps = {
  id: 0,
  path: '/backoffice/login',
  parent_id: null,
  permission_slugs: [],
  hasAccess: true,
  label: 'Login',
  key: 'login',
}

const USER_LOGIN: RouterMenuProps = {
  id: 0,
  path: '/login',
  parent_id: null,
  permission_slugs: [],
  hasAccess: true,
  label: 'Login',
  key: 'login',
}

const ADMIN_FORGET_PASSWORD: RouterMenuProps = {
  id: 0,
  path: '/backoffice/forget-password',
  parent_id: null,
  permission_slugs: [],
  hasAccess: true,
  label: 'Forget Password',
  key: 'forget_password',
}

const FORGET_PASSWORD: RouterMenuProps = {
  id: 0,
  path: '/forget-password',
  parent_id: null,
  permission_slugs: [],
  hasAccess: true,
  label: 'Forget Password',
  key: 'forget_password',
}
const RESET_PASSWORD: RouterMenuProps = {
  id: 0,
  path: '/reset-password',
  parent_id: null,
  permission_slugs: [],
  hasAccess: true,
  label: 'Reset Password',
  key: 'reset_password',
}
const CHANGE_PASSWORD: RouterMenuProps = {
  id: 0,
  path: '/backoffice/change-password',
  parent_id: null,
  permission_slugs: [],
  hasAccess: true,
  label: 'Change Password',
  key: 'change_password',
}
// dashboard

const DASHBOARD: RouterMenuProps = {
  id: 1,
  path: '/backoffice/dashboard',
  parent_id: null,
  icon: 'dashboard-icon',
  label: 'Dashboard',
  key: 'dashboard',
  permission_slugs: [],
  hasAccess: Boolean(checkPermission('dashboard')),
  // hasAccess: true,
  // permission_slugs: [
  //   domainTypes['EMPLOYEE'],
  //   domainTypes['ORGANISATION'],
  //   domainTypes['ASSESSOR'],
  // ],
  // breadcrumb: ["DASHBOARD"],
  isSidebarMenu: true,
}

const USER_PROFILE: RouterMenuProps = {
  id: 8118,
  path: '/backoffice/profile',
  parent_id: null,
  icon: 'cart-icon',
  label: 'reciept',
  key: 'user-profile',
  permission_slugs: [],
  hasAccess: true,
}

const SWITCH_ACCOUNT: RouterMenuProps = {
  id: 911,
  path: '/switch-account',
  parent_id: null,
  isDetails: true,
  icon: 'user',
  label: 'Switch Account',
  key: 'switch-account',
  permission_slugs: [],
  breadcrumb: ['SWICTH_ACCOUNT'],
  isSidebarMenu: false,
  // hasChild: true,
}

const REQUEST_ACCESS: RouterMenuProps = {
  id: 9111,
  path: 'request-access',
  parent_id: 911,
  icon: 'user',
  label: 'Request Access',
  key: 'request-access',
  permission_slugs: [],
  breadcrumb: ['SWITCH_ACCOUNT', 'REQUEST_ACCESS'],
  isSidebarMenu: false,
}

const REQUESTED_ACCESS: RouterMenuProps = {
  id: 9112,
  path: 'requested-access',
  parent_id: 911,
  icon: 'user',
  label: 'Requested Access',
  key: 'requested-access',
  permission_slugs: [],
  breadcrumb: ['SWITCH_ACCOUNT', 'REQUESTED_ACCESS'],
  isSidebarMenu: false,
}

//Contacts

const HOME: RouterMenuProps = {
  id: 2,
  path: '/home',
  parent_id: null,
  label: 'Home',
  icon: 'home',
  key: 'home',
  permission_slugs: [],
  // hasAccess: true,
  hasAccess: Boolean(checkPermission('home')),
  isSidebarMenu: true,
}

const FILE_FOLDER: RouterMenuProps = {
  id: 21,
  path: '/fund/:fund_id/job/:job_id/jobview',
  parent_id: null,
  label: 'Job View',
  key: 'job-view',
  permission_slugs: [],
  // hasAccess: true,
  hasAccess: Boolean(checkPermission('job_view')),
  isSidebarMenu: false,
}

const ADMIN_FILE_FOLDER: RouterMenuProps = {
  id: 22,
  path: '/backoffice/fund/:fund_id/job/:job_id/jobview',
  parent_id: null,
  label: 'Job View',
  key: 'job-view',
  permission_slugs: [],
  // hasAccess: true,
  hasAccess: Boolean(checkPermission('admin_job_view')),
  isSidebarMenu: false,
}

const USERS: RouterMenuProps = {
  id: 3,
  path: '/backoffice/user',
  parent_id: null,
  label: 'Users',
  icon: 'user',
  key: 'user',
  permission_slugs: [],
  // hasAccess: true,
  hasAccess: Boolean(checkPermission('users_sidebar')),
  isSidebarMenu: true,
}
const ADMIN_USER_LOG: RouterMenuProps = {
  id: 31,
  path: '/backoffice/admin-log/:id',
  parent_id: null,
  label: 'Administrators',
  key: 'admin-log',
  permission_slugs: [],
  // hasAccess: true,
  hasAccess: Boolean(checkPermission('user_log_sidebar')),
  isSidebarMenu: false,
}

const CLIENTS: RouterMenuProps = {
  id: 4,
  path: '/backoffice/clients',
  parent_id: null,
  label: 'Clients',
  icon: 'building-icon',
  key: 'client',
  permission_slugs: [],
  // hasAccess: true,
  hasAccess: Boolean(checkPermission('clients_sidebar')),
  isSidebarMenu: true,
}

const CLIENT_VIEW: RouterMenuProps = {
  id: 32,
  path: '/backoffice/client/:id/fund',
  parent_id: 4,
  label: 'Client View',
  icon: 'building-icon',
  key: 'client-view',
  permission_slugs: [],
  hasAccess: Boolean(checkPermission('client_view')),
  isSidebarMenu: false,
}

const ALL_FUNDS: RouterMenuProps = {
  id: 2,
  path: '/funds-list',
  parent_id: null,
  label: 'Funds',
  icon: 'payroll-icon',
  key: 'funds',
  permission_slugs: [],
  // hasAccess: true,
  hasAccess: Boolean(checkPermission('all_funds')),
  isSidebarMenu: true,
}

const FUNDS: RouterMenuProps = {
  id: 2,
  path: '/funds',
  parent_id: null,
  label: 'Funds',
  icon: 'payroll-icon',
  key: 'funds',
  permission_slugs: [],
  // hasAccess: true,
  hasAccess: Boolean(checkPermission('funds_sidebar')),
  isSidebarMenu: true,
}

const MANAGER_USERS: RouterMenuProps = {
  id: 4,
  path: '/backoffice/managers',
  parent_id: null,
  label: 'Managers',
  icon: 'leads-icon',
  // icon: 'workers-icon',
  key: 'manager',
  permission_slugs: [],
  // hasAccess: true,
  hasAccess: Boolean(checkPermission('managers_sidebar')),
  isSidebarMenu: true,
}

const REPORTS: RouterMenuProps = {
  id: 5,
  path: '/backoffice/reports',
  parent_id: null,
  label: 'Reports',
  icon: 'reports-icon',
  key: 'report',
  permission_slugs: [],
  // hasAccess: true,
  hasAccess: Boolean(checkPermission('reports_sidebar')),
  isSidebarMenu: true,
}

const REPORT_FUNDS: RouterMenuProps = {
  id: 52,
  path: '/backoffice/reports/funds',
  parent_id: 5,
  label: 'Fund Reports',
  key: 'report-funds',
  permission_slugs: [],
  // hasAccess: true,
  hasAccess: Boolean(checkPermission('reports_funds')),
  isSidebarMenu: false,
}

const REPORT_JOBS: RouterMenuProps = {
  id: 53,
  path: '/backoffice/reports/jobs',
  parent_id: 5,
  label: 'Job Reports',
  key: 'report-jobs',
  permission_slugs: [],
  hasAccess: Boolean(checkPermission('reports_jobs')),
  isSidebarMenu: false,
}

const REPORT_JOB_QUERIES: RouterMenuProps = {
  id: 54,
  path: '/backoffice/reports/job-queries',
  parent_id: 5,
  label: 'Job Query Reports',
  key: 'report-job-query',
  permission_slugs: [],
  hasAccess: Boolean(checkPermission('reports_job_queries')),
  isSidebarMenu: false,
}

const REPORT_LOGS: RouterMenuProps = {
  id: 55,
  path: '/backoffice/reports/logs',
  parent_id: 5,
  label: 'Log Reports',
  key: 'report-logs',
  permission_slugs: [],
  hasAccess: Boolean(checkPermission('reports_logs')),
  isSidebarMenu: false,
}

const NOTIFICATIONS: RouterMenuProps = {
  id: 6,
  path: '/backoffice/notifications',
  parent_id: null,
  label: 'Notifications',
  icon: 'notify-icon',
  key: 'notifications',
  permission_slugs: [],
  hasAccess: true,
  isSidebarMenu: true,
}

const TEMPLATES: RouterMenuProps = {
  id: 2,
  path: '/templates',
  parent_id: null,
  label: 'Templates',
  icon: 'compliances-icon',
  key: 'templates',
  permission_slugs: [],
  // hasAccess: false,
  hasAccess: Boolean(checkPermission('templates_sidebar')),
  isSidebarMenu: true,
}
// Note : The arrangements of below "router_config" object will reflect in Sidebar
export const router_config: { [key: string]: RouterMenuProps } = {
  DASHBOARD,
  USER_LOGIN,
  HOME,
  FILE_FOLDER,
  ADMIN_FILE_FOLDER,
  FUNDS,
  REPORT_FUNDS,
  REPORT_JOBS,
  REPORT_JOB_QUERIES,
  REPORT_LOGS,
  TEMPLATES,
  USERS,
  LOGIN,
  FORGET_PASSWORD,
  ADMIN_FORGET_PASSWORD,
  RESET_PASSWORD,
  CHANGE_PASSWORD,
  USER_PROFILE,
  ADMIN_USER_LOG,
  MANAGER_USERS,
  CLIENTS,
  CLIENT_VIEW,
  REPORTS,
  NOTIFICATIONS,
  SWITCH_ACCOUNT,
  REQUEST_ACCESS,
  REQUESTED_ACCESS,
  ALL_FUNDS,
}
